<div [ngClass]="{'sub-entities-scroll-container': !isInSlider}"
  *ngIf="candidateDetails?.candidateReferenceId != null || candidateDetails?.candidateId != null">

  <!-- ═══════════════════════════════════════
       V3 DESIGN — Candidate Profile
       ═══════════════════════════════════════ -->
  <ng-container *ngIf="designVersion === 'v3'">
    <!-- Candidate Details + Activity Summary (two-column box layout, mirrors job Details tab) -->
    <div class="jc-v3-tab-content">
      <div class="jc-v3-detail-grid">

        <!-- Candidate Details box -->
        <div class="jc-v3-detail-card">
          <h4>Candidate Details</h4>
          <!-- Primary / Secondary skills render as a comma-joined string
               to match the V3 job-profile-detail card pattern
               (`job-profile-detail.component.html:12-13`) — keeps the
               Candidate Details card visually consistent with the Job
               Details card and avoids the chip-tag wall on candidates
               with long skill lists. -->
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.primarySkills?.length">
            <span class="jc-v3-d-label">Primary Skills</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.primarySkills?.join(', ') || '–' }}</span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Secondary Skills</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.secondarySkills?.join(', ') || '–' }}</span>
          </div>
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.totalExperience">
            <span class="jc-v3-d-label">Experience</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.totalExperience }} Years</span>
          </div>
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.workMode">
            <span class="jc-v3-d-label">Work Mode</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.workMode }}</span>
          </div>
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.availableIn">
            <span class="jc-v3-d-label">Availability</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.availableIn }}</span>
          </div>
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.engagementType">
            <span class="jc-v3-d-label">Engagement Type</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.engagementType }}</span>
          </div>
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.workAuthorization">
            <span class="jc-v3-d-label">Work Authorization</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.workAuthorization }}</span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Security Clearance</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.securityClearance ? 'Yes' : 'No' }}</span>
          </div>
          <!-- AUDIT_04 Batch 4 — contact info (phone + email) ported from
               V2 header. Recruiters could not see contact info on the V3
               profile summary body previously. -->
          <div class="jc-v3-detail-row" *ngIf="candidateDetails?.phone">
            <span class="jc-v3-d-label">Phone</span>
            <span class="jc-v3-d-val">
              <ng-icon name="tablerPhone" style="margin-right:4px;"></ng-icon>
              {{ countryDialCode }} {{ candidateDetails?.phone }}
            </span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Email</span>
            <span class="jc-v3-d-val">
              <ng-icon name="tablerMail" style="margin-right:4px;"></ng-icon>
              {{ candidateDetails?.candidateEmailId || '-' }}
            </span>
          </div>
          <!-- AUDIT_04 Batch 4 — rate label + rate breakdown (parity
               with V2 `:188-210`). `rateLabel` toggles between
               "Submitted for" / "Applied for" based on job context. -->
          <!-- Rate can come back blank/null from the API; a `!= undefined` guard
               still lets "" through and renders a half-empty "– USD /" chip, so
               fall back to an explicit "Not Available" instead. -->
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">{{ rateLabel || 'Pay Rate' }}</span>
            <span class="jc-v3-d-val">
              <ng-icon name="tablerCurrencyDollar" style="margin-right:4px;"></ng-icon>
              <ng-container *ngIf="candidateDetails?.targetRateFrom && candidateDetails?.targetRateTo; else noRateProfileSummary">
                {{ candidateDetails?.targetRateFrom }} – {{ candidateDetails?.targetRateTo }}
                {{ getCurrency(candidateDetails?.country) }} / {{ getPayType(candidateDetails?.payType) }}
              </ng-container>
              <ng-template #noRateProfileSummary>Not available</ng-template>
            </span>
          </div>
        </div>

        <!-- Activity Summary box -->
        <div class="jc-v3-detail-card">
          <h4>Activity Summary</h4>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Total Views</span>
            <span [title]="candidateDetails?.viewedByCount + ' Views'" class="jc-v3-d-val">{{ candidateDetails?.viewedByCount | compactCount }}</span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Total Likes</span>
            <span [title]="candidateDetails?.likesCount + ' Likes'" class="jc-v3-d-val">{{ candidateDetails?.likesCount | compactCount }}</span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Invites</span>
            <span [title]="candidateDetails?.interestShownCount + ' Invites'" class="jc-v3-d-val">{{ candidateDetails?.interestShownCount | compactCount }}</span>
          </div>
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Created On</span>
            <span class="jc-v3-d-val">{{ candidateDetails?.updatedOn | timezoneDate:'MM/dd/yyyy' }}</span>
          </div>
          <!-- AUDIT_04 Batch 4 — multi-resume listing (parity with V2
               `:368-400` resume table). Owner sees all resumes with
               per-row Set Primary + Delete actions; non-owner sees
               only the primary resume's Download button. -->
          <!-- Resume section - always visible -->
          <div class="jc-v3-detail-row">
            <span class="jc-v3-d-label">Resumes</span>
            <!-- Show resume list when resumes exist -->
            <div class="jc-v3-d-val" *ngIf="candidateDetails?.resumeAttached && candidateDetails?.resumes?.length > 0">
              <ul class="jc-v3-resume-list">
                <ng-container *ngFor="let resume of candidateDetails?.resumes; let ri = index">
                  <li class="jc-v3-resume-row" *ngIf="candidateDetails?.createdBy === userId || resume?.isDefault">
                    <span class="jc-v3-resume-name" [title]="stripResumeIdPrefix(resume?.fileName)">
                      {{ resume?.fileName | spliter }}
                      <span class="jc-v3-resume-primary" *ngIf="resume?.isDefault">Primary</span>
                    </span>
                    <div class="jc-v3-resume-actions">
                      <button class="jc-v3-resume-icon-btn"
                              title="Download"
                              (click)="downloadResume(candidateDetails, userId, resume?.fileId, resume?.fileName)">
                        <ng-icon name="tablerDownload"></ng-icon>
                      </button>
                      <button *ngIf="candidateDetails?.createdBy === userId && !resume?.isDefault"
                              class="jc-v3-resume-icon-btn"
                              title="Set as primary"
                              (click)="setPrimary(resume?.fileId, $event)">
                        <ng-icon name="tablerStar"></ng-icon>
                      </button>
                      <button *ngIf="candidateDetails?.createdBy === userId && !resume?.isDefault"
                              class="jc-v3-resume-icon-btn jc-v3-resume-delete"
                              title="Delete"
                              (click)="deleteResumes(resume?.fileId)">
                        <ng-icon name="tablerTrash"></ng-icon>
                      </button>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
            <!-- Show "Not Uploaded" when no resumes -->
            <span class="jc-v3-d-val" *ngIf="!candidateDetails?.resumeAttached || !candidateDetails?.resumes?.length">Not Uploaded</span>
          </div>
        </div>

      </div>

      <!-- Candidate Summary -->
      <div class="jc-v3-desc-card" *ngIf="candidateDetails?.resumeSummary">
        <h4>Candidate Summary</h4>
        <div [ngxSummernoteView]="candidateDetails?.resumeSummary" style="word-wrap:break-word;"></div>
      </div>
    </div>

    <!-- Profile Details (work experience, education, certs) -->
    <div class="jc-v3-section-block" *ngIf="refresh">
      <app-candidates-profile-details [candidateDetails]="candidateDetails"></app-candidates-profile-details>
    </div>
  </ng-container>

  <!-- ═══════════════════════════════════════
       V2 DESIGN (existing)
       ═══════════════════════════════════════ -->
  <div class="hpanel" *ngIf="designVersion !== 'v3'">
    <div class="panel-body br-bt-none">
      <div class="col-sm-12 card-details">
        <div class="row hpanel panel-body">
          <h5 class="panel-heading hbuilt col-sm-12 no-bt-br">  Candidate Details    </h5>  

          <div class="pad-0 col-sm-5 flex-row-center" *ngIf="candidateDetails?.user?.userType!='FREELANCE_RECRUITER'">
            <img
              *ngIf="candidateDetails?.user?.workExperience?.length > 0 && !candidateDetails?.user?.workExperience[0]?.businessLogo"
              class="normal-image" src="assets/images/gallery/company.png" alt="Business Logo">
            <img
              *ngIf="candidateDetails?.user?.workExperience?.length && candidateDetails?.user?.workExperience[0]?.businessLogo"
              class="normal-image" [src]="url+candidateDetails?.user?.workExperience[0]?.businessLogo"
              alt="Object Photo">
            <ng-container *ngFor="let experience of candidateDetails?.user?.workExperience; let i = index;">
              <div style="color: rgb(0 0 0)" *ngIf="experience.currentOrganization">
                {{ experience?.organisationName }}
                <ng-icon name="tablerStar"></ng-icon>
              </div>
            </ng-container>
          </div>
          <div class="pad-0 col-sm-5 flex-row-center" *ngIf="candidateDetails?.user?.userType=='FREELANCE_RECRUITER'">

            <div *ngFor="let experience of candidateDetails?.user?.workExperience; let i = index;">
              <div *ngIf="candidateDetails.postedBehalfOf == experience.organisationName">
                <img *ngIf="experience?.businessLogo==null" class="normal-image" src="assets/images/gallery/company.png"
                  alt="Business Logo">
                <img *ngIf="experience?.businessLogo!=null" class="normal-image" [src]="url+experience?.businessLogo"
                  alt="Object Photo">
              </div>
            </div>
            <ng-container *ngFor="let experience of candidateDetails?.user?.workExperience; let i = index;">
              <div *ngIf="candidateDetails.postedBehalfOf == experience.organisationName">
                {{ experience?.organisationName }}
                <ng-icon name="tablerStar"></ng-icon>
              </div>
            </ng-container>
          </div>

          <div class="col-sm-7 p-0 justify-content-left flex">
            <app-connection-template [page]="'candidate-profile-1'"
              [connectionStatus]="candidateDetails?.connectionStatus" [counterpartsDetails]="candidateDetails?.user"
              [values]="candidateDetails" [module]="'candidate'"></app-connection-template>
          </div>
        </div> 

        <div class="row hpanel panel-body"> 
          
          <div class="item">
            <div class="row card-item-2">
              <div class="col-sm-12 flex-1rem-center">
                <div class="col-sm-1 p-0">
                  <div *ngIf="candidateDetails?.photo != undefined">
                    <img alt="logo" class="photo-style" [src]="url + candidateDetails.photo">
                  </div>
                  <div *ngIf="candidateDetails?.photo ==undefined &&userType!='JOB_SEEKER'">
                    <div class="circles"
                      [style.background-color]="getColortwo(candidateDetails?.firstName, candidateDetails?.lastName)">
                      <div class="circle-text"
                        [style.color]="getTextColor(candidateDetails?.firstName, candidateDetails?.lastName)">{{
                        getInitialstwo(candidateDetails?.firstName,
                        candidateDetails?.lastName) }}</div>
                    </div>
                  </div>
                  <div
                    *ngIf="candidateDetails?.photo == undefined &&userType=='JOB_SEEKER'&&candidateDetails?.user?.photo!=undefined">
                    <img alt="logo" class="photo-style" [src]="url + candidateDetails?.user?.photo">
                  </div>
                  <div
                    *ngIf="candidateDetails?.photo ==undefined &&userType=='JOB_SEEKER'&&candidateDetails?.user?.photo==undefined">
                    <div class="circles"
                      [style.background-color]="getColortwo(candidateDetails?.firstName, candidateDetails?.lastName)">
                      <div class="circle-text"
                        [style.color]="getTextColor(candidateDetails?.firstName, candidateDetails?.lastName)">{{
                        getInitialstwo(candidateDetails?.firstName,
                        candidateDetails?.lastName) }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-9 p-0">
                  <div class="title-grid-container">
                    <div class="dp-flx">
                      <h6 class="fw-bold p-0 ellllipses wd-12">
                        {{candidateDetails?.firstName|titlecase}} {{candidateDetails?.lastName|titlecase}}
                      </h6>
                      <div class="sts-lbl" [ngClass]="{
                        'br-pd active-label': candidateDetails?.status === 'ACTIVE',
                        'br-pd draft-label': candidateDetails?.status === 'DRAFTED',
                        'br-pd inactive-label': candidateDetails?.status === 'INACTIVE',
                        'br-pd deactivated-label': candidateDetails?.status === 'BLOCKED'
                      }">
                        {{candidateDetails?.status === "BLOCKED" ? 'Blocked' : candidateDetails?.status === "INACTIVE" ?
                        'Unavailable' :candidateDetails?.status === "DRAFTED" ? 'Draft' : 'Available'}}
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-sm-2 pr-0 candidate-profile-action-container">

                  <input #myFileInput2 style="display: none;" type="file" (click)="myFileInput2.value=null"
                    (change)="fileChangeEvent($event, profilePhotoUpload)" accept=".jpg,.jpeg,.png" />
                  <div>
                    <button id="candidate_profile_invite_apply_button" title="Invite To Apply" class="btn-primary btn"  style="color:#fff !important;"
                      [ngClass]="{'disabled': !candidateDetails?.availability || candidateDetails?.status != 'ACTIVE'}"
                      *ngIf="candidateDetails?.createdBy!=userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
                      (click)="invite(candidateDetails, jobsupplytemplate, connectionTemplate)">Invite To Apply</button>
                  </div>
                  <div class="panel-tools" [ngClass]="{'disabled': toggleOpen}"
                    *ngIf="candidateDetails?.status != 'BLOCKED' ">
                    <label class="cp-toggle">
                      <input id="toogleBar" (click)="enableCandidate($event)"
                        [disabled]="candidateDetails?.createdBy != userId ||candidateDetails?.status == 'DRAFTED' "
                        [ngModel]="candidateDetails?.status == 'ACTIVE'" [ngModelOptions]="{standalone: true}"
                        type="checkbox">
                      <span [ngClass]="candidateDetails?.createdBy != userId ? 'cp-toggle-track cp-toggle-hidden' : 'cp-toggle-track'"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-1 p-0 edit-candidate-job-pencil"
                  *ngIf="candidateDetails?.createdBy === userId && candidateDetails?.status != 'BLOCKED'">
                  <!-- <img class="normal-image" alt="pencil image" src="assets/icon/pencil-transparent.png"
                    (click)="edit(candidateDetails)"> -->

                  <button id="candidate_profile_edit_button" class="edit-button-900">
                    <ng-icon name="tablerPencil" (click)="edit(candidateDetails)" class="svg-position"></ng-icon>
                  </button>

                </div>
              </div>

              <div class="col-sm-12 flex-1rem-center">
                <h5 class="ellllipses wd-30 lin-ht-int m-0 fw-bold" title="{{candidateDetails?.jobTitle}}">
                  {{candidateDetails?.jobTitle}}
                </h5>
                <div *ngIf="candidateDetails?.resumeAttached==false">
                  <button id="candidate_profile_upload_resume_button" title="Upload Resume" class="btn-primary btn "
                    *ngIf="candidateDetails?.createdBy==userId &&candidateDetails?.status=='ACTIVE'"
                    (click)="model(candidateDetails,template,'null')">Upload Resume</button>
                </div>
              </div>
              <div class="col-sm-12 flex-1rem-center">
                <ng-icon name="tablerCalendar" class="svg-position"></ng-icon>
                <p class="mr-0">
                  Created On {{ candidateDetails?.updatedOn | timezoneDate:'MM/dd/yyyy'}} |
                </p>
                <p class="mr-0">
                  Candidate ID: {{candidateDetails?.candidateReferenceId}}
                </p>
              </div>

              <div class="col-sm-12 urgent-hire-container" *ngIf="getActiveUrgencyDays(candidateDetails) as urgencyDays" style="margin-top: 4px;">
                <span class="urgent-hire-badge"><ng-icon name="tablerFlame" class="urgent-hire-icon"></ng-icon> Hot</span>
              </div>

              <div class="col-sm-12 flex-1rem-center">

                <ng-container *ngIf="candidateDetails?.phone">
                  <ng-icon name="tablerPhone" class="svg-position"></ng-icon>
                  <span>{{ countryDialCode }} {{ candidateDetails.phone }}</span>
                </ng-container>


                <ng-icon name="tablerMail" class="svg-position"></ng-icon>
                <span>{{ candidateDetails?.candidateEmailId || '-' }}</span>
              </div>


              <div class="col-sm-12 flex-1rem-center">
                <ng-icon name="tablerMapPin" class="svg-position"></ng-icon>
                {{ gigsumoService.formatLocation(candidateDetails?.city, candidateDetails?.state,
                candidateDetails?.country) }}
              </div>
              <div class="col-sm-12 flex-1rem-center" [title]="'Pay Rate: ' +
                            (candidateDetails?.country === 'US' ? '$' : '') +
                            candidateDetails?.targetRateFrom + ' - ' + candidateDetails?.targetRateTo + ' ' +
                            getCurrency(candidateDetails?.country) + ' / ' +
                            getPayType(candidateDetails?.payType)"
                *ngIf="candidateDetails?.targetRateFrom != undefined && candidateDetails?.targetRateTo != undefined">
                <ng-icon name="tablerCurrencyDollar" class="svg-position-tp"></ng-icon>
                Pay Rate:
                <span>
                  {{candidateDetails?.targetRateFrom}} - {{candidateDetails?.targetRateTo}}
                </span>
                <span>{{getCurrency(candidateDetails?.country)}} / {{getPayType(candidateDetails?.payType)}}</span>

              </div>

              <div class="col-sm-6 flex-1rem-center" *ngIf="jobSpecificDetails && isInSlider"
                   style="background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
                          padding: 12px 15px;
                          border-radius: 8px;
                          margin: 10px 0;
                          box-shadow: 0 2px 4px rgba(139, 92, 246, 0.1);">
                <ng-icon name="tablerCurrencyDollar" class="svg-position"  style="color: #8B5CF6;"></ng-icon>
                <strong style="color: #8B5CF6; margin-right: 8px;">{{rateLabel}}:</strong>
                <span>
                  {{jobSpecificDetails.targetRate}} {{getCurrency(candidateDetails?.country)}} / {{jobSpecificDetails.payType}}
                </span>
              </div>

              <div class="col-sm-12 flex-1rem-center">
                <ng-icon name="tablerBuilding" class="svg-position" *ngIf="candidateDetails?.totalExperience"></ng-icon>
                <span *ngIf="candidateDetails?.totalExperience"> Experience : {{candidateDetails?.totalExperience}}
                  Years</span>
                <span *ngIf="candidateDetails?.availableIn">.</span>
                <ng-icon name="tablerCalendar" class="svg-position" *ngIf="candidateDetails?.availableIn"></ng-icon>
                <span *ngIf="candidateDetails?.availableIn">Availability : {{candidateDetails?.availableIn}}</span>
                <ng-icon name="tablerBriefcase" *ngIf="candidateDetails?.engagementType" class="svg-position"></ng-icon>
                <span>{{candidateDetails?.engagementType}}</span>
              </div>

              <div class="col-sm-12 dp-flx-5">
                <div class="innerflex br-pd" [ngClass]="{'active-label': candidateDetails?.workMode}">
                  <ng-icon name="tablerCheck" *ngIf="candidateDetails?.workMode" class="svg-position"></ng-icon>
                  <span>{{candidateDetails?.workMode}}</span>
                </div>
                <!-- <div class="innerflex br-pd" [ngClass]="{'active-label': candidateDetails?.workMode=='Onsite', 'inactive-label': candidateDetails?.workMode!='Onsite'}">
                  <ng-icon name="tablerX" *ngIf="candidateDetails?.workMode!='Onsite'" class="svg-position"></ng-icon>
                  <ng-icon name="tablerCheck" *ngIf="candidateDetails?.workMode=='Onsite'" class="svg-position"></ng-icon>
                  <span>Onsite</span>
                </div>
                <div class="innerflex br-pd"  [ngClass]="{'active-label': candidateDetails?.workMode=='Remote', 'inactive-label': candidateDetails?.workMode!='Remote'}">
                  <ng-icon name="tablerX" *ngIf="candidateDetails?.workMode!='Remote'" class="svg-position"></ng-icon>
                  <ng-icon name="tablerCheck" *ngIf="candidateDetails?.workMode=='Remote'" class="svg-position"></ng-icon>
                  <span> Remote </span>
                </div> -->
                <div class="innerflex br-pd"
                  [ngClass]="{'active-label': candidateDetails?.securityClearance, 'inactive-label': !candidateDetails?.securityClearance}">
                  <ng-icon name="tablerX" *ngIf="!candidateDetails?.securityClearance" class="svg-position"></ng-icon>
                  <ng-icon name="tablerCheck" *ngIf="candidateDetails?.securityClearance" class="svg-position"></ng-icon>
                  <span>Security Clearance</span>
                </div>
                <div class="innerflex br-pd" *ngIf="candidateDetails.status=='ACTIVE'"
                  [ngClass]="{'active-label': candidateDetails?.resumeAttached, 'inactive-label': !candidateDetails?.resumeAttached}">
                  <ng-icon name="tablerX" *ngIf="!candidateDetails?.resumeAttached" class="svg-position"></ng-icon>
                  <ng-icon name="tablerCheck" *ngIf="candidateDetails?.resumeAttached" class="svg-position"></ng-icon>
                  <span>Resume</span>
                </div>
              </div>
              <div class="col-sm-12 resume-download-section" *ngIf="candidateDetails?.resumeAttached && candidateDetails?.resumes?.length > 0">
                <ng-container *ngFor="let newitem of candidateDetails?.resumes">
                  <div *ngIf="newitem?.isDefault" class="resume-single-row">
                    <button class="btn-download-resume" (click)="downloadResume(candidateDetails,userId,newitem?.fileId,newitem?.fileName)"
                            type="button" title="Download Resume" style="color:#fff !important;">
                      <ng-icon name="tablerDownload"></ng-icon>
                      Download Resume
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="card-item-2" >
              <div class="col-sm-12 p-510010 skill-row">
                <div class="col-sm-3 p-510010 skill-label">Primary Skills</div>
                <div class="col-sm-9 p-510010">
                  <div class="skills-container">
                    <span title="{{item}}" class="skill-tag" *ngFor="let item of candidateDetails?.primarySkills">
                      {{item}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 p-510010 skill-row">
                <div class="col-sm-3 p-510010 skill-label">Secondary Skills</div>
                <div class="col-sm-9 p-510010">
                  <ng-container *ngIf="candidateDetails?.secondarySkills?.length; else emptySkills">
                    <div class="skills-container">
                      <span title="{{item}}" class="skill-tag" *ngFor="let item of candidateDetails?.secondarySkills">
                        {{item}}
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #emptySkills>
                    <div class="text-muted">_</div>
                  </ng-template>
                </div>
              </div>
              
            </div>
          </div>

        </div> 
          <div class="hpanel panel-body row card-item-2"> 
          <div class="panel-heading hbuilt no-bt-br fw-b6">  Candidate Summary    </div>  
          <div class="col-sm-12 pad-0">
            <div class="wrap-break" *ngIf="candidateDetails?.resumeSummary; else noSummary"
              style="word-wrap: break-word;" [ngxSummernoteView]="candidateDetails?.resumeSummary"></div>
            <!-- <div>{{candidateDetails?.resumeSummary | json}}</div> -->
          </div>
        </div>
        <div style="margin-right: -15px;   margin-left: -15px;" *ngIf="refresh" >
          <app-candidates-profile-details [candidateDetails]="candidateDetails" ></app-candidates-profile-details>
        </div> 

      
      </div>
    </div>
  </div>
  <app-candidate-template (updateStatusAndFilters)="oncandidateFilterReload($event)"
    (candidateReload)="oncandidateReload($event)"></app-candidate-template>

  <ng-template #profilePhotoUpload>
    <div class="common-header-flex">
      <div>Profile Photo</div>
      <button><span class="common-close" (click)="closePhoto2()" aria-hidden="true">&times;</span></button>
    </div>


    <div class="modal-body">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
        format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>


    <div class="modal-footer" style="border-radius: 5px !important;">
      <button class="btn btn-default m-r-18 w70" (click)="closePhoto2()">Cancel</button>
      <button class="btn primary-btn m-r-18 w70" (click)="imageLoaded2()">Apply</button>
    </div>
  </ng-template>

  <ng-template #connectionTemplate>
    <app-connection-template [page]="'candidate-profile'" [connectionStatus]="connectionStatus"
      [counterpartsDetails]="counterpartsDetails" [values]="values" [module]="'candidate'"></app-connection-template>
  </ng-template>
  <ng-template #jobsupplytemplate>
    <app-new-job [focus]="focus" [screenName]="'invite-job-listing'" [filterData]="passCandidateData"></app-new-job>
  </ng-template>

  <!-- <ng-template #content let-modal>

    <div class="modal-body-padding">

      <div class="common-header-flex">
        <div>Resumes List</div>
        <button>
          <span (click)="closemodel()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="panel-body">
        <div class="table-responsive">
          <table cellpadding="1" cellspacing="1" class="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Resumes</th>
                <th scope="col">Edit</th>
                <th scope="col">Delete</th>
                <th scope="col">Download</th>
                <th scope="col">Primary Resume</th>
              </tr>
            </thead>
            <tbody *ngFor="let resume of resumelist; let i = index">
              <tr>
                <th scope="row">{{i+1}}</th>

                <td>{{resume.fileName | spliter}}</td>
                <td>
                  <button (click)="opens(template,resume.fileId,resume.isDefault)"><ng-icon name="tablerPencil"></ng-icon></button>
                </td>
                <td>
                  <button [disabled]="resume.isDefault==true" (click)="deleteResumes(resume.fileId)"><ng-icon name="tablerTrash"></ng-icon> </button>
                </td>
                <td>
                  <button> <a href="{{url+resume?.fileId}}" target="_blank" download> <ng-icon name="tablerDownload"></ng-icon></a>
                  </button>
                </td>
                <td><input type="checkbox" class="largerCheckbox" [checked]="resume.isDefault==true"
                    [disabled]="resume.isDefault==true" (click)="setPrimary(resume.fileId, $event)"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="custom-panel-footer">
        <div class="panel-footer">
          <div class="footer-flex">
            <button class="btn btn-default resume" (click)="closemodel()"> Cancel</button>
            <button class="btn  btn-primary resume" (click)="model(candidateDetails,template,'null')"> Attach
              Resume</button>
          </div>
        </div>
      </div>


    </div>

  </ng-template> -->


  <ng-template #template>

    <div class="common-header-flex">
      <div> Resume Upload </div>
      <button>
        <span class="common-close" (click)="close()">&times;</span>
      </button>
    </div>

    <div class="panel-body">
      <div class="col-sm-12" style="margin-top: 17px;">
        <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
          <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
            (click)="fileDropRef.value=''"
            (change)="fileBrowseHandler($event.target.files)" />

          <div class="file-icon-908">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="12" y1="18" x2="12" y2="12"></line>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
          </div>
          <div>
            <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
          </div>
          <div>
            <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
              area.</label>
          </div>
          <div for="fileDropRef">
            <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
          </div>
          <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
              <polyline points="13 2 13 9 20 9"></polyline>
            </svg>
            <span class="file-name-908" [title]="fileDragdrop?.fileName || fileDragdrop?.name">{{fileDragdrop?.fileName || fileDragdrop?.name}}</span>
            <ng-icon name="tablerX" class="file-remove-908" (click)="removeFiles()"></ng-icon>
          </div>
        </div>
      </div>
      <!-- <div class="col-sm-12" style="margin-top: 17px;">
        <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef">
          <input #fileDropRef style="display: none" type="file" accept=".pdf,.doc,.docx,.txt" id="fileDropRef"
            (change)="fileBrowseHandler($event.target.files)" />
          <i class="file-icon-908"></i>
          <div>
            <label class="upload-title-908" for="fileDropRef">Upload Your Resume</label>
          </div>
          <div>
            <label class="upload-instruction-908" for="fileDropRef" id="aad">Drag your files here or click in this
              area.</label>
          </div>
          <div>
            <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
          </div>
        </div>
        <div *ngIf="fileDragdrop" class="file-preview-908 file-preview-entered-908">
          <span class="file-name-908">{{fileDragdrop?.name | truncate: 28}}</span>
          <ng-icon name="tablerX" class="svg-position file-remove-908" (click)="removeFiles()"></ng-icon>
          <button class="file-remove-908" (click)="removeFiles()">×</button>
        </div> 
      </div> -->


      <!-- <div class="files-list" *ngIf="fileDragdrop">

        <div class="upFileWrap">
          <div class="fileUPinfo" style="cursor:pointer;">
            <ng-icon name="tablerNews"></ng-icon>
            <h4 class="name"> {{ fileDragdrop?.name }} </h4>
            <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
              <ng-icon name="tablerDownload" aria-hidden="true"></ng-icon>
            </p>
            <div title="Remove File" (click)="removeFiles()" class="uploadTiimes">x</div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button class="btn btn-default" (click)="close()">Cancel </button>
          <button class="btn  btn-primary btn-save" (click)="editresumes()">Save </button>
        </div>
      </div>
    </div>

  </ng-template>
</div>

<ng-template #noSummary>
  No candidate summary available.
</ng-template>